import { defineStore } from 'pinia';

export const useSidebarStore = defineStore('sidebar', {
  state: () => ({
    mobileOpen: false,
  }),

  actions: {
    updateMobileOpen(value) {
      this.mobileOpen = value;
    },
  },
});
